import { createSlice } from "@reduxjs/toolkit";
const initialState ={
    apercuShow : false,
    ajoutsuccess : false,

}

const RetourFournisseur = createSlice({
    name : 'RetourFournisseurData',
    initialState,
    reducers :{
        showapercu:(state,action) =>{
            state.apercuShow=action.payload
        }, 
        ajoutsuccess:(state,action) =>{
            state.ajoutsuccess=action.payload
        },  
    }
})
export const {showapercu,ajoutsuccess} = RetourFournisseur.actions;
export default RetourFournisseur.reducer;